import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200/80 bg-background-50/90 backdrop-blur-md"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="flex h-16 md:h-[72px] w-full items-center justify-between px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5 group">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 text-xl">
            <i className="ri-water-flash-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              {siteInfo.brand}
            </span>
            <span className="mt-0.5 text-[11px] tracking-widest text-foreground-500">
              DAILY MELON
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {siteInfo.nav.map((item) => {
            const active =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  active
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/roundup"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line text-primary-500"></i>
            今日热榜
          </Link>
          <Link
            to="/about#subscribe"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅瓜单
          </Link>
        </div>

        <button
          type="button"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {siteInfo.nav.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about#subscribe"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅瓜单
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}